/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SavePalReauthNoteRequest
 */
export interface SavePalReauthNoteRequest {
    /**
     * 
     */
    text: string;
}

/**
 * Check if a given object implements the SavePalReauthNoteRequest interface.
 */
export function instanceOfSavePalReauthNoteRequest(value: object): value is SavePalReauthNoteRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function SavePalReauthNoteRequestFromJSON(json: any): SavePalReauthNoteRequest {
    return SavePalReauthNoteRequestFromJSONTyped(json, false);
}

export function SavePalReauthNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavePalReauthNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function SavePalReauthNoteRequestToJSON(json: any): SavePalReauthNoteRequest {
    return SavePalReauthNoteRequestToJSONTyped(json, false);
}

export function SavePalReauthNoteRequestToJSONTyped(value?: SavePalReauthNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

